






































import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import AccessService from '@/domain/access/service/access.service';
import Pagination from '@/domain/pagination.entity';
import Access from '@/domain/access/domain/access.entity';
import Rules from '@/shared/rules/rules';
import AccessionConfigurationList from './accession-configuration-list.component.vue';

@Component({
  components: { AccessionConfigurationList },
})
export default class AccessionConfiguration extends Vue {
  @Prop() businessUnitId!: string;

  emailSuffix: string = '@db1.com.br';

  username: string = '';

  loadingList: boolean = true;

  loadingPost: boolean = false;

  accesses: Access[] = [];

  rules: Rules = new Rules();

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'username|asc',
  });

  postAccess(): void {
    const { form }: any = this.$refs;
    if (!form.validate()) return;
    this.loadingPost = true;
    AccessService.postAccess(this.businessUnitId, this.username)
      .then(() => {
        VbSnackbarService.showSuccess(`Acesso liberado para o e-mail ${this.username}${this.emailSuffix}`);
        form.reset();
        this.getAccesses();
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => {
        this.loadingPost = false;
      });
  }

  @Watch('businessUnitId')
  onBusinessUnitChange(): void {
    this.pagination.page = 1;
    this.getAccesses();
  }

  getAccesses(): void {
    this.loadingList = true;
    AccessService.getAccesses(this.businessUnitId, this.pagination).then((result: any) => {
      this.accesses = result.data.content.map((it) => new Access(it));
      this.pagination.pageCount = result.data.totalPages;
      this.pagination.total = result.data.totalElements;
    }).catch(VbSnackbarService.handleHttpError)
      .finally(() => {
        this.loadingList = false;
      });
  }

  deleteAccess(accessId): void {
    AccessService.deleteAccess(accessId).then(() => {
      VbSnackbarService.showSuccess('Acesso removido.');
      this.getAccesses();
    }).catch(VbSnackbarService.handleHttpError);
  }

  updateTable(pagination: Pagination): void {
    this.pagination = pagination;
    this.pagination.verifyPage();
    this.getAccesses();
  }

  updateProfile({ id, profile }): void {
    this.loadingList = true;
    AccessService.updateAccess(id, profile)
      .then(() => VbSnackbarService.showSuccess('Perfil atualizado.'))
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingList = false);
  }
}
